/** Spread onto an element for Amplitude autocapture. */
export interface AmplitudeElementProps {
  'data-amp-default-track'?: true;
}

export interface AmplitudeElementPropsOptions {
  /**
   * Include this element in click autocapture.
   * Buttons, links, inputs, and the other default targets are already included.
   * Adds `data-amp-default-track`.
   */
  includeInClickTracking?: boolean;
}

/** Props that opt an element into Amplitude click autocapture. */
export function getAmplitudeProps({
  includeInClickTracking = false,
}: AmplitudeElementPropsOptions = {}): AmplitudeElementProps {
  const props: AmplitudeElementProps = {};
  if (includeInClickTracking) {
    props['data-amp-default-track'] = true;
  }
  return props;
}
